import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { Alert, Table, Col, Row, Rate, Icon, Tooltip, Button, Popover, Badge, Menu, Dropdown, Modal, Checkbox, Input } from 'antd';
import moment from 'moment';
import { PossWarrantyIcon, RubleIcon, OrderIcon, UrgentIcon, ToolIcon, BadWorkIcon, RetryIcon, AttachIcon, WaitingIcon } from '../../resource/icons';
import WaitingModal from './components/WaitingModal/WaitingModal';
import { ReactComponent as HousingStockIcon } from "../../resource/HousingStockIcon.svg";
import { ReactComponent as MasterIcon } from "../../resource/Master.svg";
import { ReactComponent as MasterСontractorIcon } from "../../resource/MasterСontractor.svg";
import AttachmentsPanelContainer from '../attachments-panel.container';
import { authHeader } from '../../helpers/auth-header';
import { dspxDiffDays, declOfNum } from '../../helpers/dspx-utils';
import { client } from '../../actions';
import { requestListActions } from './request-list.actions';
import warrantyActions from '../../actions/warranty.actions';
import executeTimeActions from '../../actions/execute-time.actions';
import serviceActions from '../../actions/service.actions';
import addressActions from '../../actions/address.actions';
import { history } from '../../helpers/history';
import { alertActions } from '../../actions/alert.actions';
import { actions as newRequestAction } from '../CreateRequest/new-request.actions';
import { requestsConstants } from './requests.constants';
import { dspxSorter } from '../../helpers/dspx-sort';
import NotesPanelContainer from '../notes-panel.container';
import WarrantyPanel from '../warranty-panel';
import MarksPanel from '../../components/marks-panel';
import PhoneRecords from '../../components/PhoneRecords/PhoneRecords';
import { setItemToCalendar } from '../../actions/itemToCalendar';
import WorkerCell from '../../components/WorkerCell/WorkerCell';
import { workerKeys } from '../../components/WorkerCell/constants';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import {
  CreationMethod,
  CompleteModal,
  Priority,
  ExecuteDateWithActions,
	InvoiceManager,
} from '../../components/requestComponents';
import { calendarTypeIds, completedStatusId } from '../../constants/requests.constants';
import { setSelectedRequest } from '../../actions/acceptanceRequestToCalendarActions';
import getRequestCalendarType from '../../requests/getRequestCalendarType';
import AddressFilterToggle from './components/AddressFilterToggle/AddressFilterToggle';
import { setPageState } from '../../crossPageInteractions/store/actions';
import ActionsCell from './components/ActionsCell/ActionsCell';
import { RequestsUserWrapper } from './components/RequestsUserWrapper/RequestsUserWrapper';
import { NavigationToHousingStock } from '../../containers/Requests/components/NavigationToHousingStock/NavigationToHousingStock';
import { createFullAddress } from '../../helpers/createFullAddress';
import { ChangeRequestWarrantyContent, warrantyIds } from './components/WarrantyManagement';
import { ReactComponent as HouseCertificateIcon } from '../../resource/HouseCertificateIcon.svg'
import { requestsActions } from './requests.actions';
import { filterActions } from './request-filter/model';
import normalizeApplicantPhone from './request-filter/lib/normalizeApplicantPhone';
import ControlDateWithActions from '../../components/requestComponents/RequestExecutionDate/ui/ControlDateWithActions/ControlDateWithActions';
import { openModalAlertDate } from '../../actions/alert-date.actions';
import { ChessFlatContent } from './components/ChessFlat';
import { ReactComponent as HintsIcon } from '../../resource/HintsIcon.svg';
import { RequestHintsModal } from './components/RequestHintsModal/RequestHintsModal';

//import WarrantyDocumentsContainer from '../containers/warranty-documents-container'
//import WarrantyInfo from './warranty-info'

const isContractor = (speciality) => speciality?.toLowerCase() === "подрядчик";
const notWarrantyId = 0;

const {
	RequestInvoiceBlock,
  RequestInvoiceModalProvider,
  withSetRequestInvoiceSuccessSubscription,
} = InvoiceManager;

const SORT_ID = 'Id';
const SORT_STAGE_LIFE_CYCLE = 'StageLifeCycle';
const SORT_STAGE_LIFE_CYCLE_CURRENT = 'StageLifeCycleCurrent';
const SORT_ACCEPTANCE_LIFE_CYCLE = 'AcceptanceLifeCycle';
const SORT_CREATE_TIME = 'CreateTime';
const SORT_LIFETIME = 'Age';
const SORT_ADDRESS = 'Address';
const SORT_SERVICE = 'Service';
const SORT_EXECUTE_TIME = 'ExecuteTime';
const SORT_MASTER = 'Master';
const SORT_EXPIRED = 'Expired';
const SORT_DEADLINE = 'Deadline';
const SORT_CLOSED = 'CloseDate';
const SORT_CONTROL = 'ControlDate';
const SORT_CLOSED_NOT_DONE = 'CloseNotDoneDate';
const SORT_BY_URGENCY = 'Urgency';
const SORT_STATUS = 'Status';
const SORT_LAST_UPDATE_TIME = 'LastUpdateTime';
const orders = {
	ascend: 'Asc',
	descend: 'Desc'
}
const statusIds = {
  new: 1,
  inWork: 2,
  closed: 3,
  cancelled: 4,
  done: 5,
  doneCallHuman: 6,
}

const noEditableStatusIds = new Set([statusIds.closed, statusIds.cancelled]);
const doneStatusIds = new Set([statusIds.done, statusIds.doneCallHuman]);

const areCanChange = (request) => !noEditableStatusIds.has(request.statusId)

const confirm = Modal.confirm;
const APPLICANT_PHONE_FILTER_PLACEHOLDER = 'Телефон заявителя';

let dspxCurrentRowID = null;

function dspxExRowExit(c) {
	dspxCurrentRowID = c;

	const r = document.getElementById('dspxRow' + dspxCurrentRowID);
	if (r) {
		//r = r.parentElement.parentElement;
		r.classList.remove("current");
		r.classList.add("nocurrent");
	}
}


function dspxExRowEnter(c) {

	dspxCurrentRowID = c;

	const r = document.getElementById('dspxRow' + dspxCurrentRowID);
	if (r) {
		//r = r.parentElement.parentElement;
		r.classList.remove("nocurrent");
		r.classList.add("current");
	}

}


/*function dspxRowEnter(c) {


	//let r = this.previousSibling;
	//let c = r.getAttribute('data-row-key');

	//console.log('----- dspxRowEnter')
	//console.log(r)
	//console.log(c)
	//console.log(dspxCurrentRowID)

	if (dspxCurrentRowID !== c) {
		let r = document.getElementById('dspxRow' + dspxCurrentRowID);
		if(r) {
			r.classList.remove("current");
			r.classList.add("nocurrent");
		}
		r = document.getElementById('dspxExRow' + dspxCurrentRowID);
		if (r) {
			//r = r.parentElement.parentElement;
			r.classList.remove("current");
			r.classList.add("nocurrent");
		}
	}

	dspxCurrentRowID = c;

	let x = document.getElementById('dspxExRow' + dspxCurrentRowID);
	if (x) {
		//x = x.parentElement.parentElement;
		x.classList.remove("nocurrent");
		x.classList.add("current");
	}
	//if(r) {
	//	r.classList.remove("nocurrent");
	//	r.classList.add("current");
	//}
} */

/*function dspxRowLeave() { 
	let r = this.previousSibling;
	let c = r.getAttribute('data-row-key');
	if(dspxCurrentRowID !== c) {
		console.log(dspxCurrentRowID)
		console.log(r.getAttribute('data-row-key'))
		r.classList.remove("current") 
		r.classList.add("nocurrent") 
	}
	dspxCurrentRowID = c;
}*/

class DspxRequestList extends Component {
	constructor(props) {
		super(props)

		this.state = {
			//currentPage: 1,
			expandedRowKeys: [],
			hintsRequest: null,
			statuses: [],
			sortColumn: 'id',
			sortParam: 'Id',
			sortOrder: 'descend',
			marksPanelVisibleId: 0,
			waitingModalOpen: false,
			waitingModalRecord: null,
			waitingModalLoading: false,
			descriptionPanelVisibleId: 0,
      showDescriptionToClient: {},
			descriptionPanelValue: '',
			attachementPanelVisible: 0,
			currentPage: 1,
			sortedRequests: [],
			//pageSize: 10, 
		}

		history.listen((location, action) => {
			this.props.dispatch(alertActions.clear());
		});
	}

	resetNeedUpdateAttachments = () => {
		this.setState({ needUpdateAttachments: false });
	}

	resetNeedUpdateNotes = () => {
		this.setState({ needUpdateNotes: false });
	}

	handleCompleteModalCancel = () => {
		this.setState({ completedRequestId: undefined })
	}

  handleAfterCompleteModalSubmit = async ({ updatedRequest, formValues }) => {
    this.setState({
      completedRequestId: undefined,
    });

    if (updatedRequest) {
      const updatedRequests = this.props.requests.map((request) =>
        request.id === updatedRequest.id ? updatedRequest : request
      );

      this.props.dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: updatedRequests,
      });

      if (formValues.note.trim()) {
        this.setState({ needUpdateNotes: true });
      }

      if (formValues.files.length) {
        this.setState({ needUpdateAttachments: true });
      }
    }
  };

	changeRequestHasAttachmentProp = (isAttachment, requestId) => {
		const newRequestsArr = this.props.requests.map(newRequestsItem => {
			if (newRequestsItem.id === requestId) {
				newRequestsItem.hasAttachment = isAttachment;
			}
			return newRequestsItem;
		});
		this.props.dispatch({type: requestsConstants.UPDATE_REQUESTS, payload: newRequestsArr})
	}

	getSortParam = ({ columnKey }) => {
		switch (columnKey) {
			case 'last_update_time':
				return SORT_LAST_UPDATE_TIME;

			case 'create_time':
				return SORT_CREATE_TIME;

			case 'full_address':
				return SORT_ADDRESS;

			case 'service':
				return SORT_SERVICE;

			case 'execute_time':
				return SORT_EXECUTE_TIME;

			case 'master-executer':
				return SORT_MASTER;

			case 'id':
				return SORT_ID;

			default:
				throw new Error(`Не нашлось соответствия с columnKey = ${columnKey}`);
		}
	};

	resetSortOrder = (columnKey) => {
		this.setState({
			sortOrder: undefined,
			sortParam: this.getSortParam({ columnKey })
		})
	}

	getSortOrder = ({ param, order, isNewColumn }) => {
		if (!param) return order;

		if (isNewColumn) {
			return 'ascend'
		}

		return this.state.sortOrder || 'ascend'
	}

	setSortingState = (sortObj) => {
		const { sortColumn, sortParam } = this.state;
		const { columnKey, param, order } = sortObj;

		if (!columnKey && !param) {
			return;
		}

		const isNewColumn = sortColumn !== columnKey;

		const sortState = {
			sortColumn: columnKey,
			sortOrder: this.getSortOrder({ param, order, isNewColumn }),
			sortParam:
				param || (isNewColumn ? this.getSortParam({ columnKey }) : sortParam),
		};

		this.setState(sortState);
	};

	sortRequests = () => {
		const { sortOrder, sortParam } = this.state;
		const sortedRequests = this.props.requests.slice();

		if (sortOrder && sortParam) {
			const key = `sorter${sortParam}${orders[sortOrder]}`;
			const sorter = dspxSorter[key];
			sortedRequests.sort(sorter);
		}

		this.setState({ sortedRequests });
	};

	fetchStatuses = async () => {
		let rurl = '/Request/statuses_for_set';
		const res = await client.get(rurl, { headers: authHeader() })
		const sts = res.data
		await sts.sort((a,b)=>a.orderNum - b.orderNum)
		return sts
	}

	handleChangeStatusClick = val => {
		val.domEvent.stopPropagation()

		if (val.key == 8) {
			this.handleSetStatusClick({rid: val.item.props.rid, newStatus: val.key, 
				newStatusDescription: this.state.statuses[val.item.props.index].description }) 
		} else if (Number(val.key) === completedStatusId) {
			this.setState({completedRequestId: val.item.props.rid})
		} else {
			confirm({
				title: 'Изменить статус заявки?',
				content:
					<div>
						Заявка: <strong>{val.item.props.rid}</strong><br />
						Новый статус: <strong>{this.state.statuses[val.item.props.index].description}</strong></div>,

				onOk: () => {

					this.props.dispatch(
						requestListActions.setRequestStatus(
							val.item.props.rid,
							val.key,
							this.state.statuses[val.item.props.index].description));
				},
				onCancel: () => {
					console.log('Cancel');
				},
			})
		}
	}

	handleChangeWarrantyClick = val => {

		val.domEvent.stopPropagation();

		this.props.dispatch(warrantyActions.openWarrantyModal(val.item.props.rid, val.key));
	}

	handleSetStatusClick = ({rid, newStatus, newStatusDescription}) => {
		this.props.dispatch(executeTimeActions.openExecuteTimeModal({rid, newStatus, newStatusDescription }));
	}

	handleHistoryClick = (data) => {
		this.props.dispatch(requestListActions.openHistory(data.id))
	}

	handleMapClick = (data) => {
		this.props.dispatch(requestListActions.openMap([data]))
	}

	handleServiceClick = val => {
		val.stopPropagation();
		this.props.dispatch(serviceActions.openServiceModal(
			val.target.getAttribute('rid'),
			val.target.getAttribute('parent_service'),
			val.target.getAttribute('parent_service_id'),
			val.target.getAttribute('service_id'),
			val.target.getAttribute('house_id')
		));
	}

	handleAddressClick = (record, serviceOnly) => {
		// this.props.dispatch( newRequestAction.setRequestId(record.id))
		// this.props.dispatch( newRequestAction.applyService(record.parentServiceId))
		// this.props.dispatch( newRequestAction.applyAddrStreet(record.streetId))
		// this.props.dispatch( newRequestAction.applyAddrBuilding(record.houseId, record.serviceId))
		// this.props.dispatch( newRequestAction.setAddrFlatValue(record.addressId))
		// this.props.dispatch( newRequestAction.setSubserviceValue(record.serviceId))
		// this.props.dispatch( newRequestAction.applyPossWarranty(record.garantyId>0))
		// this.props.dispatch( newRequestAction.setWorkerValue(record.master && record.master.id))
		// this.props.dispatch( newRequestAction.setExecuterValue(record.executer && record.executer.id))
		// this.props.dispatch(addressActions.openAddressModal( {...record, serviceOnly: serviceOnly} ))
		this.props.dispatch(requestsActions.setActiveRequest({...record, serviceOnly: false}))
	}

	handleReasonClick = (record) => {
		this.props.dispatch(requestsActions.setActiveRequest({...record, serviceOnly: true}))
	}

	handleStageLifeCycleClick = (record) => {
		this.props.dispatch(requestsActions.setShowModalStage(record))
	}

	handleCopyClick = record => {
		this.props.dispatch( newRequestAction.applyAddrStreet(record.streetId))
		this.props.dispatch( newRequestAction.applyAddrBuilding(record.houseId, record.parentServiceId))
		this.props.dispatch( newRequestAction.setAddrFlatValue(record.addressId))
		this.props.dispatch( newRequestAction.setSubserviceValue(record.serviceId))
		this.props.dispatch( newRequestAction.applyService(record.parentServiceId))
		this.props.dispatch( newRequestAction.applyPossWarranty(record.garantyId>0))
		this.props.dispatch( newRequestAction.setWorkerValue(record.master && record.master.id))
		this.props.dispatch( newRequestAction.setExecuterValue(record.executer && record.executer.id))
		this.props.dispatch( newRequestAction.setOwnerData(record.clientName, record.contactPhones?.substring(1)))
		//this.props.dispatch(addressActions.openAddressModal( r ))

/*		this.props.dispatch(newRequestAction.applyAddrStreet(undefined));
		this.props.dispatch(newRequestAction.fetchAddrBuildingList(undefined));
		this.props.dispatch(newRequestAction.setServiceValue(undefined));
		this.props.dispatch(newRequestAction.setSubserviceValue(undefined))
		this.props.dispatch(newRequestAction.setWorkerValue(undefined))
		this.props.dispatch(newRequestAction.setExecuterValue(undefined)) */

		this.props.dispatch(newRequestAction.openNewRequestModal(record))

	}

	applyApplicantPhoneFilter = (phoneNumber) => {
		const phone = normalizeApplicantPhone(phoneNumber);

		if (!phone) return false;

		this.props.dispatch(requestsActions.applyPhone(phone));

		if (!this.props.filterState?.filterChanged) {
			this.props.dispatch(filterActions.setFilterChanged(true));
		}

		return true;
	}

	handleApplicantPhoneFilterPaste = (event) => {
		const target = event.target;

		if (target?.getAttribute('placeholder') !== APPLICANT_PHONE_FILTER_PLACEHOLDER) return;

		const pastedText = event.clipboardData?.getData('text');

		if (!normalizeApplicantPhone(pastedText)) return;

		event.preventDefault();
		this.applyApplicantPhoneFilter(pastedText);
	}

	//handleCopyClick = record => {
	//	const r = {...record }
	//	this.props.dispatch(newRequestAction.openNewRequestModal(r))
	//}

	saveInnerState = (request) => {
		this.props.dispatch(
			setPageState({
				page: 'Requests',
				state: {
					requestList: {
						selectedRequests: this.props.selectedRequests,
					},
					requestListInnerState: this.state,
					requestsPage: {
						requests: this.props.requests,
					},
					filterState: this.props.filterState,
					targetRequestId: request.id,
					newRequestState: {
						postRequestID: this.props.postRequestID,
					}
				},
			})
		);
	}

	handleHousingStockAddressClick = (val, request) => {
		val.stopPropagation();
		this.saveInnerState(request);

		this.props.history.push({
			pathname: `/HousingStock/company/${request.companyId}/houses/${request.houseId}/flats/${request.addressId}`,
			state: { from: 'Requests' },
		})
	};

  handleCalendarClick = async (val, request) => {
    val.stopPropagation();

    const calendarType = await getRequestCalendarType({
      requestId: request.id,
      requestParentServiceId: request.parentServiceId,
    });

    if (calendarType === calendarTypeIds.acceptance) {
			this.props.dispatch(setSelectedRequest(request))
    } else {
      this.props.dispatch(setItemToCalendar(request));

			this.saveInnerState(request);

			const searchParams = new URLSearchParams();
      searchParams.set('requestId', request.id);

      this.props.history.push({
        pathname: '/Calendar',
        search: searchParams.toString(),
        state: { from: 'Requests' },
      });
    }
  };

  handlePriorityOk = ({ requestId, priority }) => {
    return this.props.dispatch(
      requestListActions.setRequestPriority({ requestId, priority })
    );
  };

	handleFavoritesClick = record => {		
		this.props.dispatch(requestListActions.setRequestFavorite(record))
	}

	handleRatingClick = e => {
		e.stopPropagation();
	}

	handleAttachementClick = requestId => {
		this.setState((state,props)=>{ return { 
				attachementPanelVisible: state.attachementPanelVisible==requestId ? 0 : requestId }})
	}

	handleAttachementPanelVisibleChange = visible => {		
		if(visible) return
		this.setState((state,props)=>{ return { 
			attachementPanelVisible: !(props.showPreview||props.showModal) 
				? 0 : state.attachementPanelVisible }})
	}

	handleRatingChange = (v, rid, ov) => {

		if (!v) return;

		const t = v ? (ov > 0 ?
			<span>Изменить оценку с: <strong>{ov}</strong> на <strong>{v}</strong>?</span> :
			<span>Поставить оценку: <strong>{v}</strong>?</span>) :
			<span>Удалить оценку?</span>;

		confirm({
			title: 'Изменить оценку заявки?',
			content:
				<div>
					Заявка: <strong>{rid}</strong><br />
					{t}
				</div>,

			onOk: () => {
				this.props.dispatch(requestListActions.setRequestRating(rid, v, false));
			},
			onCancel: () => {
				//this.props.dispatch(requestListActions.setRequestRating(rid, ov, false));
			},
		});
	}

	markViewed(rid) {
		this.props.dispatch(requestListActions.markRequestViewed(rid));
	}

	handlePostComment = rid => {
		this.props.dispatch(requestListActions.markRequestCommented(rid));
	}

	handleBindCallToRequestSuccess = (requestId) => {
		this.props.dispatch(requestListActions.setRequestHasRecord(requestId));
	}

	componentDidMount() {
		document.addEventListener('paste', this.handleApplicantPhoneFilterPaste, true);

		if (this.props.lastState) {
			const { requestList, requestListInnerState } = this.props.lastState;
			this.props.dispatch(requestListActions.retrieveLastState(requestList));
			this.setState(requestListInnerState);
		} else {
			this.props.dispatch(requestListActions.setSelected([]));
			this.sortRequests();

			this.fetchStatuses().then(
				(data) => {
					this.setState({ statuses: data });
				},
				(err) => {
					console.log(err);
				}
			);
		}
	}

	componentWillUnmount() {
		document.removeEventListener('paste', this.handleApplicantPhoneFilterPaste, true);
	}

	componentDidUpdate(prevProps, prevState) {
		const { requests: prevRequests } = prevProps;
		const { requests } = this.props;

		const { sortParam: prevParam, sortOrder: prevOrder } = prevState;
		const { sortParam, sortOrder } = this.state;

		if (
			prevRequests !== requests ||
			prevParam !== sortParam ||
			prevOrder !== sortOrder
		) {
			this.sortRequests(requests);
		}
	}

	onTableChange = (pagination, filters, sorter) => {
		const { columnKey, order } = sorter || {};
		const { sortOrder, sortColumn } = this.state;

		if (sortOrder !== order || sortColumn !== columnKey) {
			this.setSortingState(sorter);
		}
	};

	onHeaderCell = c => ({
		title: 'TITLE'
	})

	onTableRow = (record,index) => ({
		//onClick: () => {this.onRowClick(record)},
		id: 'dspxRow' + record.id,
		style: {
			borderLeft: this.props.selected && record.id == this.props.selected.id ? '18px solid #003db2' : 
			 record.firstViewDate ? "unset" : "18px solid #5db6ee",  
		},
	})

	onRowClick = (request) => {
		//this.props.dispatch(requestListActions.setSelectedRequest({request}));
	}

	handleHintsClick = (request) => {
		this.setState({ hintsRequest: request });
	}

	handleHintsModalClose = () => {
		this.setState({ hintsRequest: null });
	}

	expandedTableRowRender = (record, index, indent, expanded) => {
		const canChange = areCanChange(record);
		const canChangeDesc = canChange && this.props.userInfo.CanChangeDescription;

		const DescriptionPanel = <div style={{ textAlign: 'right', width: '360px' }}>
			<Input.TextArea
				onChange={this.handleDescriptionPanelChange}
				value={this.state.descriptionPanelValue}
				type="textarea" autosize={{ minRows: 2, maxRows: 5 }} style={{ marginBottom: '10px' }} />
			<Button onClick={this.handleDescriptionPanelCancel} style={{ marginRight: '10px' }}>Отмена</Button>
			<Button onClick={this.handleDescriptionPanelOk} type="primary">OK</Button></div>

			const bcl = ''//record.id == dspxCurrentRowID ? 'current' : 'nocurrent';

		const isAccessAddFile = canChange && this.props.userInfo.CanAddFileToRequest 

		return <div id={'dspxExRow' + record.id} onMouseEnter={()=>{dspxExRowEnter(record.id)}} 
				onMouseLeave={()=>{dspxExRowExit(record.id)}}
				className={`dspx-query-detail ${bcl}`}
				style={{ padding: '0px 8px 10px 30px', 
					borderLeft: this.props.selected && record.id == this.props.selected.id ? '9px solid #003db2' 
						: record.firstViewDate ? "unset" : "9px solid #5db6ee" }}>
			<Row gutter={16}>
				<Col span={1}>
					<PhoneRecords
						hasRecord={record.hasRecord}
						requestId={record.id}
						onBindCallSuccess={() => this.handleBindCallToRequestSuccess(record.id)}
					/>
					{!record.hasAttachment &&
						<Popover
							visible={this.state.attachementPanelVisible == record.id}
							onVisibleChange={this.handleAttachementPanelVisibleChange}
							content={
								<AttachmentsPanelContainer
									request={record.id}
									showWarrantyDocs={record.garantyId === notWarrantyId}
									needUpdate={this.state.needUpdateAttachments}
									resetNeedUpdate={this.resetNeedUpdateAttachments}
									hasattachment={record.hasAttachment}
									changeEntityHasAttachmentProp={
										this.changeRequestHasAttachmentProp
									}
									hideUploadBox={!canChange}
									hideActions={!canChange}
								/>
							}
							title={<div style={{color: "#0995ed", fontSize: 18 }}>
										<Icon type="paper-clip" /><span> Вложения</span></div>} 
							trigger='click' placement='right'>
							{isAccessAddFile && (
								<Tooltip mouseLeaveDelay={0} title="Добавить вложения">
									<Button ghost shape="circle" style={{ fontSize: '10px', marginTop: '5px' }} 
											onClick={() => {this.handleAttachementClick(record.id)}} >
										<AttachIcon grey={(!record.hasAttachment).toString()} style={{ height: '20px', marginTop: '0px' }} />
									</Button>
								</Tooltip>
							)}	
						</Popover>}
					{!record.isWaiting && canChange &&
						<Tooltip mouseLeaveDelay={0} placement="topLeft" title='Включить признак "Ожидание"'>
							<Button ghost shape="circle" style={{ fontSize: '10px', marginTop: '5px' }}
									onClick={() => {this.handleWaitingClick(record)}} >
								<WaitingIcon grey="true"  />
							</Button>
						</Tooltip>
					}

					<Tooltip mouseLeaveDelay={0} title="Подсказки">
						<Button ghost shape="circle" style={{ fontSize: '10px', marginTop: '5px' }}
								onClick={() => {this.handleHintsClick(record)}} >
							<HintsIcon style={{ width: '20px', height: '20px', marginTop: '0px', color: '#0995ed' }} />
						</Button>
					</Tooltip>
					
					{record.garantyId === warrantyIds.notWarranty &&
						canChange && (
							<ChangeRequestWarrantyContent
								request={record}
								actionProps={{ style: { marginTop: '5px' } }}
							/>
						)}
				</Col>
				<Col span={7}>
					{/* {record.createUser && ( <CreateUser createUser={record.createUser} /> )} */}
					{record.contactPhones && <div>
						<Icon type="phone" style={{ marginRight: '4px' }} /> 
						<PhoneNumber phoneNumber={record.contactPhones} name={record.clientName} />
						{record.clientName && <Icon type="user" style={{ marginRight: '4px', marginLeft: '8px' }} />}
						{record.clientName}
					</div>}

					<div>
						<Icon type="file-text" style={{ marginRight: '4px' }} />
						{record.service} : {record.description} 
						{canChangeDesc && <Popover
							placement="rightTop"
							autoAdjustOverflow={false}
							content={DescriptionPanel}
							title={
								<div style={{color: "#0995ed", fontSize: 18 }}><Icon type="file-text" /><span>Описание</span></div>
							} 
							trigger='click'
							visible={ this.state.descriptionPanelVisibleId == record.id}
							onVisibleChange={visible => { this.handleDescriptionPanelVisibleChange(record.id, record.description, visible) }} 				 
						>								
							<Tooltip mouseLeaveDelay={0} title="Редактировать описание">
								<Button ghost size='small' shape='circle' style={{ marginLeft: 2, fontSize: '10px' }} >
									<Icon type='edit' style={{margin:0}} />
								</Button>
							</Tooltip>
						</Popover>}
            {canChangeDesc && record.description && 
              <Tooltip mouseLeaveDelay={0} title="Показывать собственнику">
                <Button 
                  onClick={() => this.handleChangeShowDescription({
                    description: record.description, 
                    requestId: record.id, 
                    showToClient: this.state.showDescriptionToClient[record.id]
                  })}
                  ghost
                  size='small' 
                  shape='circle' 
                  style={{ marginLeft: 2, fontSize: '10px' }} 
              >
                  {this.state.showDescriptionToClient[record.id] ? 
                    <Icon type='eye-o' style={{ margin: 0 }} /> : 
                    <Icon type='eye-invisible' style={{ margin: 0 }} />
                  }
                </Button>
              </Tooltip>
            }
          </div>
				</Col>
				<Col span={7} >
					<NotesPanelContainer
						request={record.id}
						needUpdate={this.state.needUpdateNotes}
						resetNeedUpdate={this.resetNeedUpdateNotes}
						isnotes={record.existNote}
						onPostComment={
							!record.existNote
								? (rid) => {
										this.handlePostComment(rid);
									}
								: null
						}
						canChange={canChange}
					/>
				</Col>
				<Col span={9} >
					{record.garantyId !== notWarrantyId && (
						<WarrantyPanel requestId={record.id} canChange={canChange} />
					)}
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={2} >
										
					<Tooltip mouseLeaveDelay={0} title="История">
							<Button rid={record.id} ghost shape="circle" style={{ }}
								onClick={e => {
									e.stopPropagation()
									this.handleHistoryClick(record) 
								}}>
								<Icon type='history' style={{ fontSize: '18px', color: "#ccc", marginTop: '3px' }} />
							</Button>
					</Tooltip>
					
					{<Tooltip mouseLeaveDelay={0} title="Карта">
							<Button rid={record.id} ghost shape="circle" style={{ }}
								onClick={e => {
									e.stopPropagation()
									this.handleMapClick(record) 
								}}>
								<Icon type='environment' style={{ fontSize: '18px', color: "#ccc", marginTop: '3px' }} />
							</Button>
							</Tooltip>}

				</Col>
				<Col span={22} >
				</Col>
			</Row>
	</div> 
}

	tableSelectionChange = (selectedRowKeys, selectedRows) => {

		// if (this.props.goResort) this.props.dispatch({ type: requestsConstants.UNSET_RESORT });

		this.props.dispatch(requestListActions.setSelected(selectedRows));
	}

	/*tableSelectAll = (selected, selectedRows, changeRows) => {

		const ids = selected ? this.props.requests.map(el=>el.id) : [];

		this.props.dispatch(requestListActions.setSelected(ids));
	}*/

	onCheckAllChange = (e) => {

		// if (this.props.goResort) this.props.dispatch({ type: requestsConstants.UNSET_RESORT });

		const data = e.target.checked ? this.props.requests : [];
		this.props.dispatch(requestListActions.setSelected(data));
	}

	handleStateClick = (e) => {
		e.stopPropagation()
	}

  handleMarksPanelVisibleChange = (rid, visible) => {
		this.setState({ marksPanelVisibleId : visible ? rid : 0 })		
  };

	// handleOnClearAlertDate = (rid) => {
	// 	this.setState({ marksPanelVisibleId : 0 })		

	// 	confirm({
	// 		title: 'Очистить поле "Дата контроля"?',
	// 		onOk: () => {
	// 			this.props.dispatch( requestListActions.setRequestControlDate( { requestId: rid, date: null }));
	// 		},
	// 		onCancel: () => {
	// 			console.log('Cancel');
	// 		},
	// 	})
	// }

		handleOnChangeImmediate = (rid, e, record) => {
		this.setState({ marksPanelVisibleId : 0 })		

		confirm({
			title: 'Изменить признак заявки?',
			content:
				<div>
					Заявка: <strong>{rid}</strong><br />
					{e ? 'Установить':'Снять'} признак <strong>Аварийная</strong></div>,

			onOk: () => {
				// if(!e) {
				// 	this.props.dispatch( requestListActions.setRequestMark( rid, 'immediate', e ? 1 : 0));
				// 	this.handleOnClearAlertDate(rid);
				// 	return
				// }



				// if(!record?.alertDateTime) {
				// 	this.props.dispatch(openModalAlertDate({data: record, isRequestForImmediate: true}))
				// 	return
				// }
				
				this.props.dispatch( requestListActions.setRequestMark( rid, 'immediate', e ? 1 : 0));
			},
			onCancel: () => {
				console.log('Cancel');
			},
		})
	}

	handleOnChangeChargeable = (rid, e) => {
		this.setState({ marksPanelVisibleId : 0 })		
		confirm({
			title: 'Изменить признак заявки?',
			content:
				<div>
					Заявка: <strong>{rid}</strong><br />
					{e ? 'Установить':'Снять'} признак <strong>Платная</strong></div>,

			onOk: () => {
				this.props.dispatch( requestListActions.setRequestMark(rid, 'chargeable', e ? 1 : 0));
			},
			onCancel: () => {
				console.log('Cancel');
			},
		})
	}

	handleWaitingClick = (record) => {
		this.setState({
			waitingModalOpen: true,
			waitingModalRecord: record,
		})
	}

	handleWaitingModalCancel = () => {
		this.setState({ waitingModalOpen: false, waitingModalRecord: null })
	}

	handleWaitingModalOk = async (comment) => {
		const { waitingModalRecord } = this.state
		if (!waitingModalRecord) return

		this.setState({ waitingModalLoading: true })

		const isSuccess = await this.props.dispatch(
			requestListActions.setRequestWaiting(
				waitingModalRecord.id,
				!waitingModalRecord.isWaiting,
				comment
			)
		)

		this.setState({
			waitingModalLoading: false,
			waitingModalOpen: isSuccess ? false : this.state.waitingModalOpen,
			needUpdateNotes: isSuccess ? true : this.state.needUpdateNotes,
		})
	}

	handleOnChangeInternal = (rid, e) => {
		this.setState({ marksPanelVisibleId : 0 })		

		confirm({
			title: 'Изменить признак заявки?',
			content:
				<div>
					Заявка: <strong>{rid}</strong><br />
					{e ? 'Установить':'Снять'} признак <strong>Внутренняя</strong></div>,

			onOk: () => {
				this.props.dispatch( requestListActions.setRequestMark(
					rid,
					'internal',
					{
						"IsInternal": e ? true : false
					}
				));
			},
			onCancel: () => {
				console.log('Cancel');
			},
		})
	}

  handleDescriptionPanelVisibleChange = (rid, des, visible) => {
		this.setState({ descriptionPanelVisibleId : visible ? rid : 0, descriptionPanelValue : visible ? des : '' })		
  }

  handleDescriptionPanelOk = () => {
		this.setState({ descriptionPanelVisibleId : 0 })		
		if(this.state.descriptionPanelValue) this.props.dispatch(
			requestListActions.setRequestDescription(this.state.descriptionPanelVisibleId, this.state.descriptionPanelValue));
  }

	handleDescriptionPanelCancel = () => {
		this.setState({ descriptionPanelVisibleId : 0 })		
  }

	handleDescriptionPanelChange = v => {
		this.setState({ descriptionPanelValue : v.target.value })		
  }

  handleChangeShowDescription = ({ description, requestId, showToClient }) => {
    if ({ description, requestId, showToClient }) {
        this.props.dispatch(
            requestListActions.setRequestDescriptionExt({
                requestId,
                description,
                showToClient,
            })
        ).then(() => {
            this.setState({
                showDescriptionToClient: {
                    ...this.state.showDescriptionToClient,
                    [requestId]: !showToClient,
                },
            });
        });
    }
  }


	onTableRowExpand = (expanded, record) => {
		const keys = this.state.expandedRowKeys
    const showDescriptionToClientList = this.state.showDescriptionToClient
    if(expanded){
        keys.push(record.id);
        if (!showDescriptionToClientList[record.id]) {
          showDescriptionToClientList[record.id] = record.showDescriptionToClient;
        }
		}
		else {
			for( var i = 0; i < keys.length; i++){ 
				if ( keys[i] === record.id) {
					keys.splice(i, 1);
        }
		 }
		}
    this.setState({
      expandedRowKeys: keys,
      showDescriptionToClient: showDescriptionToClientList
    }); 

		!record.firstViewDate && this.markViewed(record.id) 
}

handlePageChange = (page, pageSize) => {
	this.setState({
		currentPage: page,
		//expandedRowKeys: []
	});
	
}

onShowSizeChange = (current, pageSize) => {
	this.props.dispatch(requestListActions.setPageSize(pageSize))
}

	/*	tableFooterRender = data => { 
	
			return (
				<div style={{ textAlign:'left', paddingLeft:'25px' }}>
					<span >Заявок: {this.state.selectedRequestsID.length}/{this.props.requests.length} </span>
				</div>
			) 
		}*/

	onExpanderMenu = val=>{

		const pages = Math.ceil(this.props.requests.length / this.props.pageSize);
		const page = this.state.currentPage > pages ? pages : this.state.currentPage;
		
		const start = (page-1)*this.props.pageSize;
		let stop = start+this.props.pageSize;

		if(stop>this.props.requests.length) stop = this.props.requests.length;

		const keys = this.state.expandedRowKeys.slice();

		if(val.key===`expand_all`) {
			for(let i=start;i<stop;i++) 
			{
				const id = this.props.requests[i].id;
				if (keys.indexOf(id) == -1) keys.push(id);				
			}
		}
		else {
			for(let i=start;i<stop;i++) 
			{
				const id = this.props.requests[i].id;
				const idx = keys.indexOf(id);
				if (idx!= -1) keys.splice(idx,1);				
			}
		}

		this.setState({expandedRowKeys: keys, currentPage: page}); 
	}

	changeInvoiceDataSuccess = (updatedRequest) => {
		if (updatedRequest) {
			const { requests, dispatch } = this.props;

			const updatedRequests = requests.map((request) =>
				request.id === updatedRequest.id ? updatedRequest : request
			);

			dispatch({
				type: requestsConstants.UPDATE_REQUESTS,
				payload: updatedRequests,
			});
		}
		
	}

	render() {
		const canChangeWarranty = this.props.userInfo.CanChangeWarranty;
		const expander_menu = (<Menu onClick={this.onExpanderMenu}>
			<Menu.Item key={`expand_all`} ><Icon type="column-height" />Развернуть все</Menu.Item>
			<Menu.Item key={`collapse_all`} ><Icon type="vertical-align-middle" /> Свернуть все</Menu.Item>
		</Menu>)

		const colApplicantCreator = {
			title: 'Заявитель/Создатель',
			key: 'applicant_and_creator',
			width: 160,
			render: (text, record) => { 
				return <div style={{fontSize: '13px', display: 'flex', flexDirection: 'column', gap: '8px'}}>
					<WorkerCell
						request={record} 
						workerKey={workerKeys.applicant} 
						renderContent={({ withCursor }) => <RequestsUserWrapper request={record} withCursor={withCursor} contentType='applicant' />}
						workerObj={{fullName: record.clientName, phones: record.contactPhones?.split(', ')}}
					/>
					<WorkerCell
						request={record} 
						workerKey={workerKeys.creator} 
						renderContent={({ withCursor }) => <RequestsUserWrapper request={record} withCursor={withCursor} contentType='creator' />}
						workerObj={{fullName: record.createUser?.fullName, phones: record.createUser?.phone?.split(', '), specialityName: record.createUser?.specialityName}}
						canCall={record?.createUser?.speciality?.toLowerCase() !== 'диспетчер' && record?.createUser?.phone}
					/>
				</div>
			}
		}

		const columns = [
			{	title: 
				<div title='' style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
					<span>Номер</span>
					{this.props.filterState.valueCheckedStage && (
						<Tooltip mouseLeaveDelay={0} title="по стадиям помещения при создании заявки">
							<HouseCertificateIcon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_STAGE_LIFE_CYCLE
										? this.setSortingState({
												param: SORT_STAGE_LIFE_CYCLE,
												columnKey: 'id',
											})
										: this.resetSortOrder('id');
								}}
								style={{
									color: this.state.sortParam === SORT_STAGE_LIFE_CYCLE ? '#0995ed' : '#afafaf', cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
				</div>,
			dataIndex: 'id',
			key: 'id',
			width: 80,
			align: 'right',
			sorter: true,
			sortOrder: (this.state.sortParam === SORT_ID || this.state.sortParam === SORT_STAGE_LIFE_CYCLE) && this.state.sortOrder,
			render: (text, record) => {
				const canChange = areCanChange(record);
				const canRatingChange = this.props.userInfo.CanSetRating && canChange;
				const canChangeRequestStage = this.props.userInfo.CanChangeRequestStage;
				const dispatcher = this.props.userInfo.Dispatcher;

				const dispatcherDispexValue = 'Own';
				const dispatcherOtherValue = 'Other'

				const showChessFlatContent = dispatcher === dispatcherDispexValue || dispatcher === dispatcherOtherValue;

				return (
					<div style={{ position: 'relative', minWidth: '80px' }}>
						{record.externalNumber && (
							<div style={{
								fontSize: '12px',
								whiteSpace: 'nowrap',
							}}>{record.externalNumber}</div>
						)}
						{this.props.filterState.valueCheckedStage && record.stageAddressLifeCycle && (
							<div>
								<Tooltip title="Стадия помещения при создании заявки">
									<span
										style={{
											color: '#17A9F1',
											fontFamily: 'Segoe UI',
											fontSize: '12px',
											whiteSpace: 'nowrap',
											cursor: canChangeRequestStage ? 'pointer' : 'default',
										}}
										onClick={
										canChangeRequestStage
											? (e) => {
													e.stopPropagation();
													this.handleStageLifeCycleClick(record);
												}
											: undefined
										}
									>
										{record.stageAddressLifeCycle.name}
									</span>
								</Tooltip>
							</div>
						)}
						<div style={{ whiteSpace: 'nowrap' }}>
							{record.hasAttachment && (
								<span
									onClick={(e) => {
										e.stopPropagation();
									}}
								>
									<Popover
										visible={this.state.attachementPanelVisible == record.id}
										onVisibleChange={this.handleAttachementPanelVisibleChange}
										content={
											<AttachmentsPanelContainer
												showWarrantyDocs={record.garantyId === notWarrantyId}
												request={record.id}
												needUpdate={this.state.needUpdateAttachments}
												resetNeedUpdate={this.resetNeedUpdateAttachments}
												hasattachment={record.hasAttachment}
												changeEntityHasAttachmentProp={
													this.changeRequestHasAttachmentProp
												}
												hideUploadBox={!canChange}
												hideActions={!canChange}
											/>
										}
										title={
											<div style={{ color: '#0995ed', fontSize: 18 }}>
												<Icon type="paper-clip" />
												<span> Вложения</span>
											</div>
										}
										trigger="click"
										placement="right"
									>
										<Tooltip
											mouseLeaveDelay={0}
											title="Вложения"
										>
											<Button
												ghost
												shape="circle"
												style={{
													position: 'relative',
													top: '-0px',
													left: '-8px',
												}}
												onClick={() => {
													this.handleAttachementClick(record.id);
												}}
											>
												<AttachIcon
													grey={(!record.hasAttachment).toString()}
													style={{ height: '18px' }}
												/>
											</Button>
										</Tooltip>
									</Popover>
								</span>
							)}
							{showChessFlatContent && (<ChessFlatContent record={record} />)}
							{/* {record.byClient &&
					<span>
						<Tooltip mouseLeaveDelay={0} title="Из приложения">
							<UserMobileIcon style={{ position: 'relative', left: '-5px', top: '-5px', height: '24px' }} />
						</Tooltip>
					</span>} */}
							{record.creationMethod && (
								<span
									onClick={(e) => {
										e.stopPropagation();
									}}
								>
									<CreationMethod
										record={record}
										methods={this.props.creationMethods}
										onOk={
											canChange
												? ({ requestId, method }) =>
														this.props.dispatch(
															requestListActions.setRequestCreationMethod({
																requestId,
																method,
															})
														)
												: undefined
										}
										iconStyle={{
											position: 'relative',
											left: '-5px',
											top: '-3px',
											height: '24px',
										}}
									/>
								</span>
							)}
							<span
								style={{
									color: '#0995ed',
									fontWeight: record.firstViewDate ? 'normal' : 'bold',
								}}
							>
								{text}
							</span>
						</div>
						<div>
							<Tooltip title={record.ratingDescription}>
								<span
									className={canRatingChange ? 'dspx-ref' : ''}
									style={{ color: '#ccc' }}
									onClick={this.handleRatingClick}
								>
									{record.rating === 'б/о' || (
										<Rate
											disabled={!canRatingChange}
											value={
												isNaN(record.rating) ? 0 : parseInt(record.rating, 10)
											}
											style={{ fontSize: 10 }}
											onChange={(e) =>
												this.handleRatingChange(
													e,
													record.id,
													isNaN(record.rating)
														? 0
														: parseInt(record.rating, 10)
												)
											}
										/>
									)}
								</span>
							</Tooltip>
						</div>
					</div>
				);
			},
		}, 
		...(this.props.requestsFailedValue
			? [
					{
						title: 'Причина',
						dataIndex: 'reason',
						key: 'reason',
						width: 200,
						sorter: true,
						render: (text, record) => {
							if(record.reason) {
								return (
									<div style={{color: 'red', fontSize: '13px', fontWeight: '500'}}>
										{text}
									</div>
								)
							}
						}
					},
				]
			: []),
		{
			title:
				<div title=''>
					<span>Создание</span>
					<span style={{ float: 'right' }}>
						<Tooltip mouseLeaveDelay={0} title="по времени выполнения">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_LIFETIME
										? this.setSortingState({
												param: SORT_LIFETIME,
												columnKey: 'create_time',
											})
										: this.resetSortOrder('create_time');
								}}
								style={{
									color: this.state.sortParam === SORT_LIFETIME ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="clock-circle" theme="outlined" />
						</Tooltip>
						<Tooltip mouseLeaveDelay={0} title="по статусу">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_STATUS
										? this.setSortingState({
												param: SORT_STATUS,
												columnKey: 'create_time',
											})
										: this.resetSortOrder('create_time');
								}}
								style={{
									color: this.state.sortParam === SORT_STATUS ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="flag" theme="outlined" />
						</Tooltip>
					</span>
				</div>,
			key: 'create_time',
			width: 190,
			align: 'left',
			sorter: true,
			sortOrder: (this.state.sortParam === SORT_LIFETIME || this.state.sortParam === SORT_STATUS ||
				this.state.sortParam === SORT_CREATE_TIME) && this.state.sortOrder,

			render: (text, record) => {
				const canChange = areCanChange(record);
				const { CanChangeImmediate, CanChangeChargeable, CanChangeStatus } = this.props.userInfo;
				const canMarksChange =
            canChange && (CanChangeImmediate || CanChangeChargeable);

				const df = record.doneDate ?
					dspxDiffDays(record.doneDate, record.createTime) :
					dspxDiffDays(0, record.createTime);
				const bgf = '#d8f2ff';
				const fgf = '#0d6aa2';
				const tlf = 'Время выполнения ' +
					(df > 0 ? (df + declOfNum(df, [' день', ' дня', ' дней'])) : '?');

				const displayItem = (statusId, recordStatusId) => {
					const additionalCheckResult = canChange
						? !doneStatusIds.has(recordStatusId) || statusId === statusIds.closed || statusId === statusIds.inWork
						: statusId === statusIds.inWork;
				
					return statusId !== recordStatusId && additionalCheckResult;
				};	

				const mi = this.state.statuses.map(
					(el) =>
						displayItem(el.id, record.statusId) && (
							<Menu.Item
								key={el.id}
								rid={record.id}
							>
								<span>{el.description}</span>
							</Menu.Item>
						)
				);
	
				const menuItems = record.garantyId === -999 ? // 0
					[...mi,
					<Menu.Divider key='div1' />,
					<Menu.Item key={'pg'} rid={record.id} >
						<PossWarrantyIcon style={{ height: '20px', verticalAlign: 'text-bottom' }} />
						<span>Возможно гарантия</span>
					</Menu.Item>
					] : mi;
				const menu = (<Menu onClick={this.handleChangeStatusClick}>{menuItems}</Menu>)

				const inviFrg = record.invoice ? (record.invoice.isFinal ? '#ffffff' : '#2669ff') : '#888'
				const invBbkg = record.invoice && record.invoice.isFinal ? '#2669ff' : 'none'        
				const invoiceSum = record.invoice && record.invoice.sum ? (record.invoice.sum / 100).toFixed(2) + " ₽" : 'не выставлен'

				return <div style={{paddingRight:20}}>
				<div style={{whiteSpace:'nowrap'}}>
					<span style={{ fontSize: '14px', marginRight: '10px' }}>
						{moment(record.createTime).format('DD.MM.YYYY HH:mm')}
					</span>
					{!isNaN(df) && df !== 0 && record.statusId != 4 &&
						<Tooltip title={tlf} mouseLeaveDelay={0}>
							<div
								style={{
									top: '4px',
									right: '4px',
									backgroundColor: bgf,
									color: fgf,
									borderRadius: '12px',
									padding: '1px 8px',
									fontSize: '12px',
									textAlign: 'center',
									cursor: 'default',
									minWidth: '20px',
									display: 'inline-block',
									cursor: 'pointer'
								}}
							>
								{df > 0 ? df : '?'}
							</div>
						</Tooltip>}
						</div>
						<div>
						{(record.garantyId === warrantyIds.possWarranty ||
							record.garantyId === warrantyIds.warranty) && (
							<ChangeRequestWarrantyContent
								request={record}
								canChange={canChange}
								actionProps={{
									style: { marginRight: '7px', height: '25px' },
								}}
							/>
						)}
            <span onClick={e => { e.stopPropagation() }} style={{display: 'inline-flex', alignItems: 'center'}}>
						<Popover								
								placement="right"
								content={<MarksPanel 
									onChangeImmediate={(e)=>{this.handleOnChangeImmediate(record.id, e, record)}}
									onChangeChargeable={(e)=>{this.handleOnChangeChargeable(record.id, e)}}
									onChangeInternal={(e)=>{this.handleOnChangeInternal(record.id, e)}}
									marks={{
										immediate: this.props.userInfo.CanChangeImmediate, 
										chargeable: this.props.userInfo.CanChangeChargeable, 
										byClient: record.byClient,
										}}
									marksValue={{
										immediate: record.isImmediate, 
										chargeable: record.isChargeable, 
										internal: record.isInternal,
										}}
									/>}
                title={<div><Icon type='tag' style={{  position:'relative', top: 3, fontSize: 20, color: '#ccc', marginRight: '7px', cursor:'pointer' }}/> Признаки</div>  } 
								trigger='click'
								visible={canMarksChange && this.state.marksPanelVisibleId == record.id}
								onVisibleChange={visible => { this.handleMarksPanelVisibleChange(record.id, visible) }} 				 
						>
					{!record.isRetry && !record.isImmediate && !record.isChargeable && !record.isInternal && !record.badWork && !record.isWaiting &&
						canChange &&
						(this.props.userInfo.CanChangeImmediate || this.props.userInfo.CanChangeChargeable) &&
						<Tooltip mouseLeaveDelay={0} title="Признаки">
							<Icon type='tag' style={{  position:'relative', top: 5, fontSize: 20, color: '#ddd', marginRight: '7px', cursor:'pointer' }} />
						</Tooltip>}
					{record.isRetry &&
						<Tooltip mouseLeaveDelay={0} title="Повторная">
							<RetryIcon style={{ marginRight: '7px', height: '25px', cursor:'pointer' }} /></Tooltip>
					}
					{record.isImmediate &&
						<Tooltip mouseLeaveDelay={0} title="Аварийная">
							<UrgentIcon style={{ marginRight: '7px', height: '25px', cursor:'pointer'}} /></Tooltip>
					}
					{record.isChargeable &&
						<Tooltip mouseLeaveDelay={0} title="Платная">
							<RubleIcon style={{ marginRight: '7px', height: '25px', cursor:'pointer' }} /></Tooltip>
					}
					{record.isInternal &&
						<Tooltip mouseLeaveDelay={0} title="Внутренняя">
							<ToolIcon style={{ marginRight: '7px', height: '25px', cursor:'pointer' }} /></Tooltip>
					}
					{record.paidServiceRequestId &&
						<Tooltip mouseLeaveDelay={0} title="Заказ">
							<OrderIcon style={{ marginRight: '7px', height: '25px', cursor:'pointer' }} /></Tooltip>
					}
					{record.badWork &&
						<Tooltip mouseLeaveDelay={0} title="Для обсуждения">
							<BadWorkIcon style={{ marginRight: '7px', height: '25px', cursor:'pointer' }} /></Tooltip>
					}
					</Popover>
					{record.isWaiting && canChange &&
						<Tooltip mouseLeaveDelay={0} title='Выключить признак "Ожидание"'>
							<WaitingIcon
								style={{marginRight: '7px'}}
								onClick={(e) => { e.stopPropagation(); this.handleWaitingClick(record) }}
							/></Tooltip>
					}
					</span>
					{CanChangeStatus ? (
						<Dropdown
							overlay={menu}
							trigger={['click']}
						>
							<Tooltip
								mouseEnterDelay={0.6}
								mouseLeaveDelay={0}
								title="Изменить статус"
							>
								<span
									onClick={this.handleStateClick}
									className={'dspx-ref'}
									style={{
										fontSize: '11px',
										cursor: 'pointer',
										color: '#0995ed',
										whiteSpace: 'nowrap',
									}}
								>
									{record.status}
								</span>
							</Tooltip>
						</Dropdown>
					) : (
						<span style={{ fontSize: '11px', color: '#0995ed' }}>
							{record.status}
						</span>
					)}
						{ !canChange || record.existNote || 
							<Tooltip mouseEnterDelay={0.6} mouseLeaveDelay={0} title="нет комментариев">
							<span style={{ 
							marginLeft: '10px', 
							fontSize: '16px',
							fontWeight: "bold",
							color: "#ff7600",
							cursor: 'pointer' 
							}}>!</span></Tooltip> }

						{record.isChargeable && (
							<RequestInvoiceBlock
							  canChange={canChange}
								request={record}
								style={{ marginTop: 10 }}
							/>
						)}
				</div>
				</div>
			}
		},  {

			title: 
				<div title='' style={{display: 'flex', alignItems: 'center'}}>
					<span>Адрес</span>
					{this.props.filterState.valueCheckedStage && (
						<div style={{ float: 'right', display: 'flex', alignItems: 'center', gap: '5px' }}>
							<Tooltip mouseLeaveDelay={0} title="по текущим стадиям помещения">
								<HouseCertificateIcon
									onClick={(e) => {
										e.stopPropagation();
										this.state.sortParam !== SORT_STAGE_LIFE_CYCLE_CURRENT
											? this.setSortingState({
													param: SORT_STAGE_LIFE_CYCLE_CURRENT,
													columnKey: 'full_address',
												})
											: this.resetSortOrder('full_address');
									}}
									style={{
										color: this.state.sortParam === SORT_STAGE_LIFE_CYCLE_CURRENT ? '#0995ed' : '#afafaf', cursor: 'pointer'
									}}
								/>
									</Tooltip>
							<Tooltip mouseLeaveDelay={0} title="по результатам приемки помещения">
								<Icon
									onClick={(e) => {
										e.stopPropagation();
										this.state.sortParam !== SORT_ACCEPTANCE_LIFE_CYCLE
											? this.setSortingState({
													param: SORT_ACCEPTANCE_LIFE_CYCLE,
													columnKey: 'full_address',
												})
											: this.resetSortOrder('full_address');
									}}
									style={{
										color: this.state.sortParam === SORT_ACCEPTANCE_LIFE_CYCLE ? '#0995ed' : '#afafaf',  cursor: 'pointer'
									}}
									type="flag" theme="outlined" />
							</Tooltip>
						</div>
					)}
				</div>,
			key: 'full_address',
			width: 160,
			sorter: true,
			sortOrder: (this.state.sortParam === SORT_STAGE_LIFE_CYCLE_CURRENT || this.state.sortParam === SORT_ACCEPTANCE_LIFE_CYCLE || this.state.sortParam === SORT_ADDRESS) && this.state.sortOrder,
			render: (_text, record) => {
				const canChange = areCanChange(record) && !record.paidServiceRequestId;
				const canAddressChange = canChange && this.props.userInfo.CanChangeAddress;
			
				return (
					<div>
						{this.props.filterState.valueCheckedStage && (
							<div style={{display: 'flex',alignItems: 'center', gap: '5px'}}>
								{record.stageAddressLifeCycleCurrent && (
									<Tooltip title="Стадия помещения текущая">
										<div
											style={{
												color: '#17A9F1',
												fontFamily: 'Segoe UI',
												fontSize: '12px',
												whiteSpace: 'nowrap',
											}}
										>
											{record.stageAddressLifeCycleCurrent.name}
										</div>
									</Tooltip>
								)}
								{record.acceptanceStatusAddressLifeCycle && (
									<Tooltip title="Результат приемки помещения">
										<div
											style={{
												color: '#17A9F1',
												fontFamily: 'Segoe UI',
												fontSize: '12px',
												whiteSpace: 'nowrap',
											}}
										>
											{record.acceptanceStatusAddressLifeCycle.name}
										</div>
									</Tooltip>
								)}
							</div>
						)}
						<NavigationToHousingStock
							placement="top"
							title="Жилой фонд"
							icon={HousingStockIcon}
							onClick={(val) => {
								this.handleHousingStockAddressClick(val, record);
							}}
						/>
						<AddressFilterToggle request={record} />
						<div>
							<div style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
								<Tooltip title={canAddressChange ? 'Изменить адрес' : ''}>
									<span
										onClick={
											canAddressChange
												? (tar) => {
														tar.stopPropagation();
														this.handleAddressClick(record);
													}
												: undefined
										}
										className={canAddressChange ? 'dspx-ref' : ''}
										style={{
											fontSize: '12px',
											marginRight: '15px',
											whiteSpace: 'nowrap',
											cursor: canAddressChange ? 'pointer' : 'default',
										}}
									>
										{createFullAddress(record)}
									</span>
								</Tooltip>
							</div>
							{(record.entrance || record.floor) && (
								<div
									style={{
										fontSize: '12px',
										color: '#888',
										whiteSpace: 'nowrap',
									}}
								>
									{record.entrance && ` подъезд: ${record.entrance} `}
									{record.floor && `этаж: ${record.floor}`}
								</div>
							)}
							{record.regionName && (
								<div
									style={{
										fontSize: '12px',
										color: '#8e8e8e',
										whiteSpace: 'nowrap',
									}}
								>
									{`мкр. ${record.regionName}`}
								</div>
							)}
						</div>
					</div>
				);
			},

		}, {

			title: <div style={{whiteSpace:'nowrap'}}>Услуга</div>,
			key: 'service',
			width: 170,
			sorter: true,
			sortOrder: this.state.sortParam === SORT_SERVICE && this.state.sortOrder,
			render: (text, record) => {
				const canChange = areCanChange(record) && !record.paidServiceRequestId;
				const canServiceChange = canChange && this.props.userInfo.CanChangeServiceType;

				return (
					<div>
						<div
							style={{
								color: '#17a9f1',
								fontSize: '13px',
								fontWeight: '500',
							}}
						>
							<Tooltip
								title="Услуга"
								mouseLeaveDelay={0}
							>
								<span
									onClick={
										canServiceChange
											? (e) => {
													e.stopPropagation();
													this.handleReasonClick(record, true);
												}
											: undefined
									}
									className={canServiceChange ? 'dspx-ref' : ''}
									style={{
										marginRight: '10px',
										cursor: canServiceChange ? 'pointer' : 'default',
									}}
								>
									{record.parentService}
								</span>
							</Tooltip>
						</div>
						<div>
							<Tooltip
								title="Причина"
								mouseLeaveDelay={0}
							>
								<span
									rid={record.id}
									parent_service={record.parentService}
									parent_service_id={record.parentServiceId}
									service_id={record.serviceId}
									house_id={record.houseId}
									onClick={canServiceChange ? this.handleServiceClick : undefined}
									className={canServiceChange ? 'dspx-ref' : ''}
									style={{
										fontSize: '12px',
										marginRight: '10px',
										cursor: canServiceChange ? 'pointer' : 'default',
									}}
								>
									{(record.service && record.service) || 'не указана'}
								</span>
							</Tooltip>
						</div>
					</div>
				);
			},
		}, {

			title:
				<div title=''>
					<span>Выполнение</span>
					<span style={{ float: 'right' }}>
						<Tooltip mouseLeaveDelay={0} title="по просроченным дням">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_EXPIRED
										? this.setSortingState({
												param: SORT_EXPIRED,
												columnKey: 'execute_time',
											})
										: this.resetSortOrder('execute_time');
								}}
								style={{
									color: this.state.sortParam === SORT_EXPIRED ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="fire" theme="outlined" />
						</Tooltip>

						<Tooltip mouseLeaveDelay={0} title="по подходящему сроку">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_DEADLINE
										? this.setSortingState({
												param: SORT_DEADLINE,
												columnKey: 'execute_time',
											})
										: this.resetSortOrder('execute_time');
								}}
								style={{
									color: this.state.sortParam === SORT_DEADLINE ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="info-circle" theme="outlined" />
						</Tooltip>

						<Tooltip mouseLeaveDelay={0} title="по дате выполнения">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_CLOSED
										? this.setSortingState({
												param: SORT_CLOSED,
												columnKey: 'execute_time',
											})
										: this.resetSortOrder('execute_time');
								}}
								style={{
									color: this.state.sortParam === SORT_CLOSED ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="check-square" theme="outlined" />
						</Tooltip>

						<Tooltip mouseLeaveDelay={0} title="по дате закрытия">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_CLOSED_NOT_DONE
										? this.setSortingState({
												param: SORT_CLOSED_NOT_DONE,
												columnKey: 'execute_time',
											})
										: this.resetSortOrder('execute_time');
								}}
								style={{
									color: this.state.sortParam === SORT_CLOSED_NOT_DONE ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="close-square" theme="outlined" />
						</Tooltip>

						{/* <Tooltip mouseLeaveDelay={0} title="по дате контроля">
							<Icon
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_CONTROL
										? this.setSortingState({
												param: SORT_CONTROL,
												columnKey: 'execute_time',
											})
										: this.resetSortOrder('execute_time');
								}}
								style={{
									color: this.state.sortParam === SORT_CONTROL ? '#0995ed' : '#afafaf',
									marginLeft: '10px', cursor: 'pointer'
								}}
								type="exclamation-circle" theme="outlined" />
						</Tooltip> */}

						<Tooltip mouseLeaveDelay={0} title="по срочности выполнения">
							<span
								onClick={(e) => {
									e.stopPropagation();
									this.state.sortParam !== SORT_BY_URGENCY
										? this.setSortingState({
												param: SORT_BY_URGENCY,
												columnKey: 'execute_time',
											})
										: this.resetSortOrder('execute_time');
								}}
								style={{
										color: this.state.sortParam === SORT_BY_URGENCY ? '#0995ed' : '#afafaf',
										marginLeft: '10px', cursor: 'pointer'
								}}
							>
								A
							</span>
						</Tooltip>
					</span>
				</div>,
			key: 'execute_time',
			width: 240,
			sorter: true,
			sortOrder: (this.state.sortParam === SORT_EXPIRED || 
				this.state.sortParam === SORT_DEADLINE|| 
				this.state.sortParam === SORT_CLOSED ||
				this.state.sortParam === SORT_CLOSED_NOT_DONE ||
				this.state.sortParam === SORT_BY_URGENCY ||
				this.state.sortParam === SORT_EXECUTE_TIME || 
				this.state.sortParam === SORT_CONTROL) && this.state.sortOrder,
			render: (text, record) => {
				const canChange = areCanChange(record) && !record.paidServiceRequestId;
				const canCalendarChange = Boolean(canChange && record.executer)

				///console.log(moment(moment(),"YYYY-MM-DD HH:mm:ss").format())
				///console.log(moment(record.executeDateTime).format())

				const dr = record.doneDateTime ?
					dspxDiffDays(record.doneDateTime, record.executeDateTime) :
					dspxDiffDays(0, record.executeDateTime);
					//const bgr = dr > 14 ? '#ff4646' : '#d8f2ff';
					//const fgr = dr > 14 ? '#fff' : '#0d6aa2';
					const bgr = '#d8f2ff';
					const fgr = '#0d6aa2';
					const tlr = 'Просрочено на ' + (dr > 0 ? (dr + declOfNum(dr, [' день', ' дня', ' дней'])
					+ (record.executeTime ? '' : ' / Нет даты назначения')) : '?');

				const dd = record.doneDateTime ? 0 : dspxDiffDays(record.executeDateTime, moment().toString());
				const dlr = dd === 0  ? 'Последний день до выполнения' :`До выполнения ${dd} ${declOfNum(dd, [' день', ' дня', ' дней'])}`

				const createCalendarTooltipTitle = ({ request, canChange }) => {
					if (!canChange) return '';

					return request.taskId
						? moment(record.taskStart).format('DD.MM.YYYY HH:mm') +
								moment(record.taskEnd).format(' - HH:mm')
						: 'Добавить в календарь';
				};

				return <> <div style={{whiteSpace: 'nowrap'}}>
					<ExecuteDateWithActions 
						request={record}
						onPriorityOk={({ requestId, priority }) => this.handlePriorityOk({ requestId, priority })}
						requestsPage
						canChange={canChange}
					/>

					{(record.taskId || canCalendarChange) &&
						<Tooltip
							title={createCalendarTooltipTitle({ request: record, canChange: canCalendarChange })} mouseLeaveDelay={0}>
							<span className={record.statusId === 3 ? '' : 'dspx-ref-hidden'}
								onClick={
									canCalendarChange
										? (val) => {
												this.handleCalendarClick(val, record);
											}
										: undefined
								}
								style={{
									marginRight: '0px', whiteSpace: 'nowrap',
									cursor: canCalendarChange ? 'pointer' : 'default'
								}}>
								<Icon type='calendar' style={{ color: record.taskId ? '#ff921e' : '#aaa', marginRight: '8px' }} />
							</span>
						</Tooltip>}
						<span onClick={e => { e.stopPropagation() }}>
							<Priority
								record={record}
								onOk={canChange ? this.handlePriorityOk : undefined}
								iconStyle={{ color: '#0995ed', cursor: canChange ? 'pointer' : 'default', marginRight: '8px' }}
							/>
						</span>

					{!isNaN(dr) && dr > 0 && record.statusId != 4 &&
						<Tooltip title={tlr} mouseLeaveDelay={0}>
						<Badge count={<Icon type="fire" theme="twoTone" style={{fontSize: 20}}  twoToneColor={ dr > 14 ? "#ff0003" : "#f44336" }/>}>
							<div
								style={{
									top: '4px',
									right: '4px',
									backgroundColor: bgr,
									color: fgr,
									borderRadius: '12px',
									padding: '4px 8px',
									fontSize: '12px',
									textAlign: 'center',
									cursor: 'default',
									minWidth: '20px',
									display: 'inline-block',
									cursor: 'pointer'
								}}
							>
								{dr > 0 ? dr : '?'}
							</div>
						</Badge>
						</Tooltip>}
					{!isNaN(dd) && (dd >= 0 && dd <= 7)  && (record.statusId === 1 || record.statusId === 2) &&
						<Tooltip title={dlr} mouseLeaveDelay={0}>
						<Badge count={<Icon type="info-circle" theme="twoTone" style={{fontSize: 20}}  twoToneColor='#0995ed'/>}>
							<div
								style={{
									top: '4px',
									right: '4px',
									backgroundColor: bgr,
									color: fgr,
									borderRadius: '12px',
									padding: '4px 8px',
									fontSize: '12px',
									textAlign: 'center',
									cursor: 'default',
									minWidth: '20px',
									display: 'inline-block',
									cursor: 'pointer'
								}}
							>
								{dd}
							</div>
						</Badge>
						</Tooltip>}
					{record.doneDate &&
						<Tooltip title='Выполнена' mouseLeaveDelay={0}>
							<div style={{ fontSize: '12px', marginRight: '10px', color: '#0995ed', whiteSpace: 'nowrap' }}>
								<svg style={{ color: '#aaa', marginRight: '8px' }} className="icon icon-clipboard"><use xlinkHref="#icon-clipboard"></use></svg>
								{record.doneDateTime && moment(record.doneDateTime).format('DD.MM.YYYY HH:mm')}
							</div>
						</Tooltip>}

						{record.closeDate && (
							<Tooltip title="Закрыта">
								<div
									style={{
										fontSize: '12px',
										color: '#000',
										whiteSpace: 'nowrap',
										marginRight: '10px',
									}}
								>
									<Icon
										type="close-square"
										style={{ marginRight: '8px', color: '#aaa' }}
									/>
									{record.closeDateTime &&
										moment(record.closeDateTime).format('DD.MM.YYYY HH:mm')}
								</div>
							</Tooltip>
						)}
				</div>
				{/* {!!record.
				 && (
						<ControlDateWithActions
							request={record}
							canChange={canChange} 
						/>
					)} */}
				</>
			}
		}, {
			title: 'Мастер/Исполнитель/УК',
			key: 'master-executer',
			width: 220,
			sorter: true,
			sortOrder: this.state.sortParam === SORT_MASTER && this.state.sortOrder,
			render: (text, record) => {
				/*const emi = this.props.executers.map(el => (!record.executer || (el.id !== record.executer.id))
					&& <Menu.Item key={el.id} rid={record.id} ><span>{el.fullName}</span></Menu.Item>)
				const emenu = (<Menu  style={{maxHeight: '90px', overflowY: "scroll"}} 
					onClick={this.handleChangeStatusClick}>{emi}</Menu>)*/
				const canChange = areCanChange(record);

				return <div style={{position: "relative", display: 'flex', flexDirection: 'column', gap: '8px'}}>
					<Tooltip
						mouseEnterDelay={0.6}
						mouseLeaveDelay={0}
						title={isContractor(record.master?.speciality) ? "Мастер подрядчик" : "Мастер"}
						placement='topLeft'
					>
						<div>
							<WorkerCell request={record} 
								considerPaidId
								canChange={canChange}
								renderIcon={() => isContractor(record.master?.speciality)
										? <Icon component={MasterСontractorIcon} /> 
										: record?.master 
											? <Icon component={MasterIcon} /> 
											: null
								}
							/>
						</div>
					</Tooltip>
					<Tooltip
						mouseEnterDelay={0.6}
						mouseLeaveDelay={0}
						title={isContractor(record.executer?.speciality) ? "Исполнитель подрядчик" : "Исполнитель"}
						placement='topLeft'
					>
						<div>
							<WorkerCell request={record}
								canChange={canChange}
								workerKey={workerKeys.executor}
								renderIcon={() => isContractor(record.executer?.speciality)
										? <Icon component={MasterСontractorIcon} />
										: record?.executer 
											? <Icon component={MasterIcon} /> 
											: null
								}
							/>
						</div>
					</Tooltip>

					{/* <Dropdown overlay={emenu} trigger={['click']}>
						<Tooltip mouseEnterDelay={0.6} mouseLeaveDelay={0} title="Изменить исполнителя">
						<span onClick={this.handleStateClick} style={{ fontSize: '11px', cursor: 'pointer', color: '#209489' }}>        
					</Dropdown> */}

					{record.companyName && <div style={{ fontSize: '11px', color: '#009fdc' }}>
						{record.companyName}
					</div>}
				</div>
			}
		},

			colApplicantCreator,

			{
				title: <div 
				style={{ position: this.props.requests?.length ? 'absolute' : 'static' }}
				>
				<Dropdown style={{position: "relative", left:-10 }} overlay={expander_menu} trigger={['hover']}>
				<Icon onClick={(e)=>{e.stopPropagation()}} type='column-height' style={{color: '#888', fontSize: 22}}/> 
				</Dropdown>				
				</div>,
				key: 'expander',
				width: 1,
			},
			{
				title: '',
				key: 'actions',
				width: 40,								
				render: (_text, record) => {
					return <ActionsCell request={record} />
				}			
		}
		];

		const rowSelection = {
			selectedRowKeys: this.props.selectedRequests,
			onChange: this.tableSelectionChange,
			onSelectAll: this.tableSelectAll,
			columnWidth: '0px',
			columnTitle: (
				<Tooltip title={this.props.selectedRequests.length === this.props.requests.length ? 'Снять все' : 'Выбрать все'} placement="right">
					<Checkbox
					indeterminate={!!this.props.selectedRequests.length
						&& (this.props.selectedRequests.length < this.props.requests.length)}
					onChange={this.onCheckAllChange}
					checked={this.props.selectedRequests.length === this.props.requests.length} />
				</Tooltip>
			),
		}

		const pegination = {
			pageSize: this.props.pageSize,
			showSizeChanger: true,
			onShowSizeChange: this.onShowSizeChange,
			pageSizeOptions: ['10','30','50','100'],
			current: this.state.currentPage,
			total: this.props.requests.length,
			onChange: this.handlePageChange,
			showTotal: (total, range) => `Заявок: ${this.props.selectedRequests.length}/${total}`,
		}

		if (!Array.isArray(this.props.requests)) return <Alert message={this.props.requests} type="error" showIcon />;

		// if (this.props.goResort && this.state.sorter) {
		// 	this.setState({sortedRequests: this.props.requests.slice().sort(this.state.sorter)})
		// 	// this.props.requests.sort(this.state.sorter);
		// } 
/*		else if(this.props.expiredList)
		{
			console.log('expiredList ========================= expiredList ')
			this.props.requests.sort(dspxSorter.sorterExpiredDesc);
		} */

		const showImportedRequests = this.props.importResult?.createdRequestIds?.length;

		const dataSource = showImportedRequests
			? (this.props.importResultRequests || [])
			: this.state.sortedRequests;

		const importPagesCount = showImportedRequests
			? Math.ceil(this.props.importResultRequests.length / this.props.pageSize)
			: 0;
		const pagination = showImportedRequests ? {
			...pegination,
			total: this.props.importResultRequests.length,
			current: this.state.currentPage > importPagesCount ? 1 : this.state.currentPage,
		} : pegination;
	
		return (
      <>
				<RequestInvoiceModalProvider onSuccess={this.changeInvoiceDataSuccess}>
					<Table
						size="middle"
						className={'dspxRequestsTable'}
						rowKey="id"
						expandedRowKeys={this.state.expandedRowKeys}
						onExpand={this.onTableRowExpand}
						rowSelection={rowSelection}
						expandRowByClick={true}
						rowClassName={() => 'dspx-table-row'}
						onChange={this.onTableChange}
						onRow={this.onTableRow}
						expandedRowRender={this.expandedTableRowRender}
						//footer={this.tableFooterRender}
						expandIconAsCell={false}
						pagination={pagination}
						columns={columns}
						dataSource={dataSource}
					/>
				</RequestInvoiceModalProvider>
				<WaitingModal
          visible={this.state.waitingModalOpen}
          isWaiting={Boolean(this.state.waitingModalRecord?.isWaiting)}
          loading={this.state.waitingModalLoading}
          onCancel={this.handleWaitingModalCancel}
          onOk={this.handleWaitingModalOk}
        />
				 <RequestHintsModal
          visible={Boolean(this.state.hintsRequest)}
          houseId={this.state.hintsRequest?.houseId}
          typeId={this.state.hintsRequest?.serviceId}
          onClose={this.handleHintsModalClose}
        />
        <CompleteModal
          visible={Boolean(this.state.completedRequestId)}
					requestId={this.state.completedRequestId}
          onCancel={this.handleCompleteModalCancel}
					afterSubmit={this.handleAfterCompleteModalSubmit}
        />
      </>
    );			
	}
}

function mapStateToProps(state) {
	const { requestListStore } = state;
	const { requests, goResort, executers, expiredList, showPreview, showModal, historyVisible, historyRequest, mapVisible, mapRequests, presetFilter, creationMethods, requestsFailedValue, importResult,
    importResultRequests, } = state.requestsStore;
	const { userInfo } = state.authentication;
	const { notifcationPopup, popupRequest } = state.notificationStore;
	const filterState = state.filterStore;
	const postRequestID = state.newRequestStore.postRequestID;
	const lastState = state.crossPageInteractionsStore.Requests;

	return {
		...requestListStore,
		creationMethods,
		requests,
		goResort,
		requestsFailedValue,
		executers,
		expiredList,
		userInfo,
		notifcationPopup,
		popupRequest,
		showPreview,
		showModal,
		historyVisible,
		historyRequest,
		mapVisible,
		mapRequests,
		presetFilter,
		filterState,
		lastState,
		postRequestID,
		importResult,
		importResultRequests,
	}
}


export default connect(mapStateToProps)(withRouter(DspxRequestList));
